import { CheckboxListFilter } from "../../UI/Table/Filters/CheckboxListFilter.tsx";
import { FilterPopoverField } from "./FilterPopoverField.tsx";
import { describeSelectedOptions } from "./salesFormat.ts";

export type FilterOption = { id: string; label: string };

export function OptionsFilterField({
  options,
  value,
  nothingSelected,
  clearLabel,
  onChange,
}: {
  options: FilterOption[];
  value: string[];
  nothingSelected: string;
  clearLabel: string;
  onChange: (values: string[]) => void;
}) {
  const labelOf = (selected: string) =>
    options.find((option) => option.id === selected)?.label ?? selected;
  return (
    <FilterPopoverField
      summary={describeSelectedOptions(value, labelOf, nothingSelected)}
      isEmpty={value.length === 0}
      clearLabel={clearLabel}
      onClear={value.length > 0 ? () => onChange([]) : undefined}
    >
      {(close) => (
        <CheckboxListFilter
          options={options.map((option) => ({
            value: option.id,
            label: option.label,
          }))}
          value={value}
          onApply={onChange}
          close={close}
        />
      )}
    </FilterPopoverField>
  );
}
